<template>
<div>
  <layout-header></layout-header>
  <div class="layout-content details line">
    <div class="layout-top-line w-334"></div>
    <div class="download-detail-header">
      <div class="detail-date">{{details && details.sCreateTime}}<span>新闻稿</span></div>
      <div class="detail-title">{{details && details.newsTitle}}</div>
    </div>
    <div id="downloadDetailContent" class="download-detail-content">
      <div v-html="details && details.newsTest"></div>
    </div>
    <details-download-list :list="downloadList"></details-download-list>
  </div>
</div>
</template>

<script>
import apiMc from "@/api/MediaCenter";
import LayoutHeader from "../../layout/MediaCenter/components/LayoutHeader";
import DetailsDownloadList from "../../components/MediaCenter/DetailsDownloadList";
export default {
  name: "DownloadDetails",
  components: {DetailsDownloadList, LayoutHeader},
  data() {
    return {
      currId: null,
      details: null,
      downloadList: []
    }
  },
  created() {
    this.currId = this.$route.params.id;
    this.getDetails();
  },
  mounted() {
    setTimeout(()=>{
      let videoList = document.querySelector("#downloadDetailContent").querySelectorAll('video');
      videoList.forEach((video)=>{
        video.style.width = '328px';
        video.style.height = '194px';
        video.style.objectFit = 'fill';
        video.setAttribute("controlsList","nodownload");
      });
    },500);
  },
  methods: {
    async getDetails() {
      this.$loading.show();
      const { success, data, errMsg } = await apiMc.newsFileList.getDetail({
        newsId: this.currId
      });
      if(success) {
        this.details = data;
        if(this.details){
          this.downloadList = this.formatFileCategories(this.details.fileCategories);
          const title = this.details.seoTitle + '|皇家加勒比国际游轮官方网站';
          const description = this.details.seoDescription;
          const keyword = this.details.seoKeyword;
          this.$store.commit('SET_META', { title, description, keyword })
        }
      } else {
        console.log(errMsg)
      }
      this.$loading.hide();
    },
    formatFileCategories(rows){
      rows && rows.forEach((row)=>{
        row.categoryType = null;
        row.fileItems && row.fileItems.forEach((item)=>{
          if(!item.reviewImageUrl && !item.videoBgImageUrl) {
            row.categoryType = 'file';
            return;
          }
        });
      });
      return rows;
    }
  }
}
</script>

<style scoped>

</style>
